import app from '../../app/app';

app.directive('onEvent', require('./onEvent'));
app.directive('compile', require('./compile').default);
